import { getStorageItem, setStorageItem } from 'app/hooks/storage/useStorage';

import { ChatVersion } from './constants/common';

const isDirectToOstro = document.body.dataset.directToOstro === 'true';

const openedInIFrame = window !== window.top;

export type RxIDs = {
  rxId: string;
  conditionId: string;
  featureFlags: string | null;
  webchatVersion: ChatVersion;
  excludeOnUrls: string[];
};

export function getIDsExecutor(resolve: (value: RxIDs) => void) {
  if (openedInIFrame && !isDirectToOstro) {
    window.addEventListener('message', (event: MessageEvent<RxIDs>) => {
      if (event.source !== window.parent) return;

      if (event.data.rxId && event.data.conditionId) {
        resolve(event.data);
      }
    });

    window.parent.postMessage('rx_give_me_IDs', '*');
  } else {
    (function check() {
      if (!window.ostro) {
        return requestAnimationFrame(check);
      }

      // Determine the condition id to use
      // baseConditionId is the default conditionId and taken from Ostro js which indicates the default language
      // langConditionId is the module condition id that is selected by the language selector or passed via URL param and has priority over the baseConditionId
      const baseConditionId = window.ostro.conditionId;

      // langConditionId is not isolated in ostroManager because it is managed by the Tailor instance only
      const langConditionId = getStorageItem(`ostroLanguageCondition-${baseConditionId}`);

      const conditionId = langConditionId || baseConditionId;

      // Store the selected landuage conditionId
      setStorageItem(`ostroLanguageCondition-${baseConditionId}`, conditionId);

      const rxId = window.ostro.rxId;
      const featureFlags = JSON.stringify(window.ostro.featureFlags ?? {});

      if (rxId && conditionId) {
        return resolve({
          conditionId,
          rxId,
          featureFlags,
          webchatVersion: window.ostro.moduleManager.webchatModuleConfigs[0]?.web_chat_version,
          excludeOnUrls: window.ostro.moduleManager.webchatModuleConfigs[0]?.exclude_on_urls || [],
        });
      }

      requestAnimationFrame(check);
    })();
  }
}

let rxIDs = new Promise(getIDsExecutor);

export const waitForIDs = () => rxIDs;

export const updateIDs = () => {
  rxIDs = new Promise(getIDsExecutor);
  return rxIDs;
};

export const getRecoveryLinkToken = () => new URLSearchParams(window.location.search).get('link_token') || '';
